export let UPLOAD_IMAGE_EVENTS = /*#__PURE__*/function (UPLOAD_IMAGE_EVENTS) {
  UPLOAD_IMAGE_EVENTS["START"] = "start";
  UPLOAD_IMAGE_EVENTS["UPLOAD_PROGRESS"] = "upload:progress";
  UPLOAD_IMAGE_EVENTS["UPLOAD_STATUS_CHANGE"] = "upload:status-change";
  UPLOAD_IMAGE_EVENTS["SUCCESS"] = "success";
  UPLOAD_IMAGE_EVENTS["ERROR"] = "error";
  UPLOAD_IMAGE_EVENTS["CHANGE"] = "change";
  return UPLOAD_IMAGE_EVENTS;
}({});
//# sourceMappingURL=upload-image-events.js.map